import { useEffect } from 'react';
import { useAtomValue } from 'jotai';
import type { SupportEvent } from '@localagent/sdk';
import { holdsIdentityAtom } from '../stores/auth/atoms';
import {
  bridgeEventStreamAtom,
  daemonPushFrameStreamAtom,
  sdkConfiguredAtom,
} from '../stores/sdk/atoms';

export function useSupportLiveRefresh(onEvent: (event: SupportEvent) => void): void {
  const ready = useAtomValue(sdkConfiguredAtom);
  const authenticated = useAtomValue(holdsIdentityAtom);
  const webStream = useAtomValue(bridgeEventStreamAtom);
  const daemonStream = useAtomValue(daemonPushFrameStreamAtom);

  useEffect(() => {
    if (!ready || !authenticated) return;
    const stream = webStream ?? daemonStream;
    if (!stream || !('onSupportEvent' in stream)) return;
    return stream.onSupportEvent(onEvent);
  }, [authenticated, daemonStream, onEvent, ready, webStream]);
}
